import { dispatch } from '../../jsCore/application/appStore'
import { CLASS_CONSTATNTS } from '../../jsCore/organizedByType/actions/analyticsActions'
import { COUNTRIES_IN_EUROPE, NO_LOCATION } from '../../jsCore/providers/geolocationProvider'

let consent

function parseConsent(data) {
  let res = Object.keys(data.vendorConsents).reduce(
    (all, key) => `${all}v_${key}=${data.vendorConsents[key] ? 1 : 0};`,
    ''
  )
  return Object.keys(data.purposeConsents).reduce(
    (all, key) => `${all}p_${key}=${data.purposeConsents[key] ? 1 : 0};`,
    res
  )
}

function getConsent() {
  return new Promise(resolve =>
    window.__cmp('getVendorConsents', null, result => resolve(parseConsent(result)))
  )
}

function analyticsEvent(action, label) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Cookie consent',
        action: action,
        label: label,
        sub_label: '',
      },
    },
  }
}

function pushConsentToDataLayer(consent) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Cookie consent',
        action: 'user consent status',
        label: ' ',
        cookieConsent: consent,
      },
    },
  }
}

function analytics() {
  var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
  var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'
  var eventer = window[eventMethod]

  function receiveOptInMessage(event) {
    function eventDataContains(str) {
      return JSON.stringify(event.data).indexOf(str) !== -1
    }
    if (event && event.data && eventDataContains('oil_shown')) {
      dispatch(analyticsEvent('consent banner impression', 'bottom sticky banner'))
    }
    if (event && event.data && eventDataContains('oil_click_advanced_settings')) {
      dispatch(analyticsEvent('consent banner learn more', 'bottom sticky banner'))
    }
    if (event && event.data && eventDataContains('oil_optin_done')) {
      consent.then(consentList => dispatch(analyticsEvent('consent banner ok click', consentList)))
    }
  }
  eventer(messageEvent, receiveOptInMessage, false)
}

export function init() {
  consent = getConsent()
  consent.then(consentList => dispatch(pushConsentToDataLayer(consentList)))
  analytics()
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/cookie_consent/cookieConsentUtils.js